import ENV from '../env'
import axios_http from 'axios'

export const axios = axios_http.create({
  baseURL: ENV.backend_url,
  headers: { 'Content-Type': 'application/json' }
})

// exporting for Vue usage as plugin
export default {
  install(Vue) {
    Vue.prototype.$axios = axios
  }
}
